import type { RouteRecordRaw } from 'vue-router';

export default {
  meta: { feature: 'container_registry' },
  path: 'iaas/container-registry/create/',
  name: 'container-registry/create',
  component: () => import('@/views/dashboard/iaas/container-registry/create/create.vue'),
} satisfies RouteRecordRaw;
